/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import LoadingSpinner from '../spinner/LoadingSpinner';
import closeIcon from '../../assets/images/close-gray.svg';

import './ConfirmationModalNew.css';

const ConfirmationModalNew = (props) => {
	const {
		showCancel = true,
		size,
		onCancel,
		backdropClassName,
		title,
		customModalBodyClass,
		showLoadingSpinner,
		children,
		cancelLabel,
		onConfirm,
		confirmLabel,
		className,
		scrollable,
		reverseButtons = false
	} = props;

	const cancelButton = (
		<button
			type="button"
			onClick={onCancel}
			className={classNames('button', { 'button-primary': reverseButtons, 'button-secondary': !reverseButtons })}
		>
			{cancelLabel || 'Cancel'}
		</button>
	);

	return (
		<Modal
			size={size || 'md'}
			show
			aria-labelledby="contained-modal-title-vcenter"
			centered
			scrollable={!!scrollable}
			className={classNames('confirmation-modal-new', className)}
			onHide={onCancel}
			backdropClassName={backdropClassName}
		>
			<Modal.Header>
				<Modal.Title id="contained-modal-title-vcenter">{title || 'Confirm'}</Modal.Title>
				<img src={closeIcon} alt="close" onClick={onCancel} className="close-icon" />
			</Modal.Header>
			<Modal.Body className={customModalBodyClass}>
				{!showLoadingSpinner ? (
					children
				) : (
					<div className="spinner-wrapper">
						<LoadingSpinner key="loading-spinner" />
					</div>
				)}
			</Modal.Body>
			<Modal.Footer>
				{showCancel && !reverseButtons && cancelButton}
				<button
					type="button"
					className={classNames('button', { 'button-primary': !reverseButtons, 'button-secondary': reverseButtons })}
					onClick={onConfirm}
					disabled={showLoadingSpinner}
				>
					{confirmLabel || 'Confirm'}
				</button>
				{showCancel && reverseButtons && cancelButton}
			</Modal.Footer>
		</Modal>
	);
};

export default ConfirmationModalNew;
